export const payoutKeys = {
    all: ['payout'],
    withdrawalHistory: (params) => [...payoutKeys.all, 'history', params],
};
